// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-row-operations a[data-v-14d5639b]{margin-right:8px}.editable-add-btn[data-v-14d5639b]{margin-top:8px}#salesForm2 .ant-form-item[data-v-14d5639b]{margin-bottom:0!important}#salesForm2 .ant-form-item-control[data-v-14d5639b],#salesForm2 .ant-form-item-control-wrapper[data-v-14d5639b],#salesForm2 .ant-form-item-label[data-v-14d5639b]{padding:0!important;line-height:1.2!important}", ""]);
// Exports
module.exports = exports;
